import { countries } from 'countries-list';
import { type Language } from '@pkgs/api';

export type Country = {
  code: string;
  name: string;
};

export const getLocalizedCountryList = (language: Language): Country[] => {
  const displayName = new Intl.DisplayNames([language], { type: 'region' });
  return Object.entries(countries)
    .map(([countryCode, country]) => ({
      code: countryCode,
      // get localized country name and fallback to english if not available
      name: displayName.of(countryCode) ?? country.name,
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
};
